module.exports = __webpack_public_path__ + "img/blt-close07.e335df24.svg";